export default "__VITE_ASSET__B22v9oNQ__"